import React, { useState } from 'react';
import logo from './logo.svg';
import RequestBetaAccessForm from './components/RequestBetaAccessForm';
import ManifestoPage from './components/ManifestoPage';
import ContactPage from './components/ContactPage';
import BookingPage from './components/BookingPage';
import DemoPage from './components/DemoPage'; // New import for the demo page
import LoginScreen from './components/LoginScreen';
import EducatorsPage from './components/EducatorsPage';
import ExecutivesPage from './components/ExecutivesPage';
import SupplyChainExample from './components/SupplyChainExample';
import RevenuePipelineExample from './components/RevenuePipelineExample';
import WorkforceExample from './components/WorkforceExample';
import HospitalORExample from './components/HospitalORExample';
import MiningManufacturingExample from './components/MiningManufacturingExample';
import PublicPolicyExample from './components/PublicPolicyExample';
import LogisticsTransportationExample from './components/LogisticsTransportationExample';
import EnergyUtilitiesExample from './components/EnergyUtilitiesExample';
import RetailEcommerceExample from './components/RetailEcommerceExample';
import AssetFleetExample from './components/AssetFleetExample';
import InnovationHub from './components/InnovationHub';
import FeaturesHub from './components/FeaturesHub';
import SolutionsHub from './components/SolutionsHub';
import SystemDynamicsPage from './components/SystemDynamicsPage';
import AISimulationPage from './components/AISimulationPage';
import UncertaintyPage from './components/UncertaintyPage';
import FeedbackLoopsPage from './components/FeedbackLoopsPage';
import MCPAgentsPage from './components/MCPAgentsPage';
import MCPPage from './components/MCPPage';
import AIMeetsSimulationPage from './components/AIMeetsSimulationPage';
import DecisionIntelligencePage from './components/DecisionIntelligencePage';
import OptimizationPage from './components/OptimizationPage';
import DecisionReadyDataPage from './components/DecisionReadyDataPage';
import ExperienceToAlignmentPage from './components/ExperienceToAlignmentPage';
import WhitepaperStrategicSimulation from './components/WhitepaperStrategicSimulation';
import NewsEventsPage from './components/NewsEventsPage';
import PrivacyPage from './components/PrivacyPage';
import CareersPage from './components/CareersPage';
import StayInTouchPage from './components/StayInTouchPage';
import GetStartedSedsi2026Page from './components/GetStartedSedsi2026Page';
import GetStartedIise2026Page from './components/GetStartedIise2026Page';
import AntiFragileNexusPage from './components/AntiFragileNexusPage';
import CodeFirstMethodologyPaperPage from './components/CodeFirstMethodologyPaperPage';
import InternalizingFragilityPaperPage from './components/InternalizingFragilityPaperPage';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import useMauticTracking from './hooks/useMauticTracking';
import CookieConsentBanner from './components/CookieConsentBanner';

function MauticTracker() {
  useMauticTracking();
  return null;
}

function App() {
  const [loginHover, setLoginHover] = useState(false);
  const [applyHover, setApplyHover] = useState(false);
  const [showBetaNotification, setShowBetaNotification] = useState(false);

  return (
    <Router>
      <ScrollToTop />
      <MauticTracker />
      <CookieConsentBanner />
      <Routes>
        <Route path="/request-early-access" element={<RequestBetaAccessForm logo={logo} />} />
        <Route path="/request-access" element={<RequestBetaAccessForm logo={logo} />} />
        <Route path="/request-beta-access" element={<RequestBetaAccessForm logo={logo} />} />
        <Route path="/get-started" element={<Navigate to="/" replace />} />
        <Route path="/appam2025" element={<Navigate to="/" replace />} />
        <Route path="/informs2025" element={<Navigate to="/" replace />} />
        <Route path="/manifesto" element={<ManifestoPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/mcp" element={<MCPPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/stay-in-touch" element={<StayInTouchPage />} />
        <Route path="/sedsi2026" element={<GetStartedSedsi2026Page logo={logo} />} />
        <Route path="/iise2026" element={<GetStartedIise2026Page logo={logo} />} />
        <Route path="/iise-2026" element={<Navigate to="/iise2026" replace />} />
        <Route path="/anti-fragile-nexus" element={<AntiFragileNexusPage logo={logo} />} />
        <Route path="/fall-2026-game" element={<Navigate to="/anti-fragile-nexus" replace />} />
        <Route path="/papers/code-first-methodology" element={<CodeFirstMethodologyPaperPage logo={logo} />} />
        <Route path="/code-first-paper" element={<Navigate to="/papers/code-first-methodology" replace />} />
        <Route path="/papers/internalizing-fragility" element={<InternalizingFragilityPaperPage logo={logo} />} />
        <Route path="/internalizing-fragility-paper" element={<Navigate to="/papers/internalizing-fragility" replace />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/book-demo" element={<BookingPage />} />
        <Route path="/schedule" element={<Navigate to="/book-demo" replace />} />
        <Route path="/calendar" element={<Navigate to="/book-demo" replace />} />
        <Route path="/try-now" element={<DemoPage logo={logo} />} />
        <Route path="/demo" element={<Navigate to="/try-now" replace />} />
        <Route path="/try" element={<Navigate to="/try-now" replace />} />
        <Route path="/educators" element={<EducatorsPage logo={logo} />} />
        <Route path="/executives" element={<ExecutivesPage logo={logo} />} />
          <Route path="/solutions" element={<SolutionsHub />} />
          <Route path="/solutions/supply-chain" element={<SupplyChainExample />} />
          <Route path="/solutions/revenue-pipeline" element={<RevenuePipelineExample />} />
          <Route path="/solutions/workforce" element={<WorkforceExample />} />
          <Route path="/solutions/hospital-or" element={<HospitalORExample />} />
          <Route path="/solutions/mining-manufacturing" element={<MiningManufacturingExample />} />
          <Route path="/solutions/public-policy" element={<PublicPolicyExample />} />
          <Route path="/solutions/logistics-transportation" element={<LogisticsTransportationExample />} />
          <Route path="/solutions/energy-utilities" element={<EnergyUtilitiesExample />} />
          <Route path="/solutions/retail-ecommerce" element={<RetailEcommerceExample />} />
          <Route path="/solutions/asset-fleet" element={<AssetFleetExample />} />
          <Route path="/solutions/financial-services" element={<Navigate to="/solutions/asset-fleet" replace />} />
          <Route path="/innovation" element={<InnovationHub logo={logo} />} />
          <Route path="/resources" element={<InnovationHub logo={logo} />} />
          <Route path="/features" element={<FeaturesHub logo={logo} />} />
          <Route path="/features/ai-assistant" element={<Navigate to="/innovation/ai-simulation" replace />} />
          <Route path="/features/scenario-experimentation" element={<Navigate to="/innovation/optimization" replace />} />
          <Route path="/features/decision-intelligence" element={<Navigate to="/innovation/decision-intelligence" replace />} />
          <Route path="/features/mcp-integration" element={<Navigate to="/innovation/mcp-agents" replace />} />
          <Route path="/features/data-layer" element={<Navigate to="/innovation/decision-ready-data" replace />} />
          <Route path="/innovation/strategic-simulation" element={<WhitepaperStrategicSimulation logo={logo} />} />
          <Route path="/innovation/system-dynamics" element={<SystemDynamicsPage />} />
          <Route path="/innovation/ai-simulation" element={<AISimulationPage />} />
          <Route path="/innovation/uncertainty" element={<UncertaintyPage />} />
          <Route path="/innovation/feedback-loops" element={<FeedbackLoopsPage />} />
          <Route path="/innovation/mcp-agents" element={<MCPAgentsPage />} />
          <Route path="/innovation/ai-meets-simulation" element={<AIMeetsSimulationPage />} />
          <Route path="/innovation/decision-intelligence" element={<DecisionIntelligencePage />} />
          <Route path="/innovation/optimization" element={<OptimizationPage />} />
          <Route path="/innovation/decision-ready-data" element={<DecisionReadyDataPage />} />
          <Route path="/innovation/experience-to-alignment" element={<ExperienceToAlignmentPage />} />
          <Route path="/news" element={<NewsEventsPage logo={logo} />} />
        <Route path="/" element={(
          <LoginScreen
            logo={logo}
            loginHover={loginHover}
            setLoginHover={setLoginHover}
            applyHover={applyHover}
            setApplyHover={setApplyHover}
            showBetaNotification={showBetaNotification}
            setShowBetaNotification={setShowBetaNotification}
          />
        )} />
        <Route path="/login" element={(
          <LoginScreen
            logo={logo}
            loginHover={loginHover}
            setLoginHover={setLoginHover}
            applyHover={applyHover}
            setApplyHover={setApplyHover}
            showBetaNotification={showBetaNotification}
            setShowBetaNotification={setShowBetaNotification}
          />
        )} />
      </Routes>
    </Router>
  );
}

export default App;
